import styled from "styled-components";

export const FilterBarWrapper = styled.div` 
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const CategoryFilterWrapper = styled.div`
    display: flex;
    align-items: center;
    border-radius: 8px;
    padding: 10px;
    height: 40px;
    // box-sizing: border-box;
    gap: 20px;
    background-color: #F2F4FA;
`

interface CategoryFilterOptionProps {
    color?: string;
    isSelected?: boolean;
}

export const CategoryFilterOption = styled.div<CategoryFilterOptionProps>`
    padding: 8px;
    border-radius: 8px;
    display: flex;
    width: 90px;
    align-items: center;
    justify-content: center;
    background-color: ${(props: any) => props.isSelected ? "white" : "inherit"};
    color: ${(props: any) => props.isSelected ? "#0058A0" : "inherit"};
    font-weight: ${(props: any) => props.isSelected ? 700 : "inherit"};
    white-space: nowrap;

    &:hover {
        cursor: pointer;
        background-color: white;
        color: ${props => props.color ? props.color : "#0058A0"};
        font-weight: 700;
    }
`